import React from "react";
import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

export const RevenueChart = ({ showChartData }) => {
    // Convert string values to numbers
    const processedData = showChartData?.map(item => ({
        ...item,
        total_billed: Number(item.total_billed),
        total_paid: Number(item.total_paid),
        total_due: Number(item.total_due),
    }));

    return (
        <div className="mt-3 px-2 w-full h-[400px]">
            <ResponsiveContainer width="100%" height="100%">
                <AreaChart data={processedData}>
                    <defs>
                        <linearGradient id="colorBilled" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#8b5cf6" stopOpacity={0.8} />
                            <stop offset="95%" stopColor="#8b5cf6" stopOpacity={0.1} />
                        </linearGradient>
                        <linearGradient id="colorPaid" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#10b981" stopOpacity={0.8} />
                            <stop offset="95%" stopColor="#10b981" stopOpacity={0.1} />
                        </linearGradient>
                        <linearGradient id="colorOutstanding" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#f59e0b" stopOpacity={0.8} />
                            <stop offset="95%" stopColor="#f59e0b" stopOpacity={0.1} />
                        </linearGradient>
                    </defs>

                    <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                    <XAxis
                        dataKey="month"
                        axisLine={false}
                        tickLine={false}
                        tick={{ fill: "#6b7280", fontSize: 12 }}
                    />
                    <YAxis
                        axisLine={false}
                        tickLine={false}
                        tick={{ fill: "#6b7280", fontSize: 12 }}
                        tickFormatter={(value) => `$${(value / 1000).toFixed(0)}k`}
                    />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: "white",
                            border: "1px solid #e5e7eb",
                            borderRadius: "8px",
                            boxShadow:
                                "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                        }}
                        formatter={(value, name) => [
                            `$${Number(value).toLocaleString()}`,
                            name === "total_billed"
                                ? "Billed"
                                : name === "total_paid"
                                    ? "Paid"
                                    : "Outstanding",
                        ]}
                        labelFormatter={(label) => `Month: ${label}`}
                    />
                    <Area
                        type="monotone"
                        dataKey="total_billed"
                        stroke="#8b5cf6"
                        fillOpacity={1}
                        fill="url(#colorBilled)"
                        strokeWidth={2}
                    />
                    <Area
                        type="monotone"
                        dataKey="total_paid"
                        stroke="#10b981"
                        fillOpacity={1}
                        fill="url(#colorPaid)"
                        strokeWidth={2}
                    />
                    <Area
                        type="monotone"
                        dataKey="total_due"
                        stroke="#f59e0b"
                        fillOpacity={1}
                        fill="url(#colorOutstanding)"
                        strokeWidth={2}
                    />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    );
};
